exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope&display=swap);", ""]);

// module
exports.push([module.id, ".text-white{color:#fff!important}.text-gray-600{color:#757575!important}.font-semibold,.text-gray-700{color:#616161!important}.not-mobile{display:initial}.mobile-only{display:none}@media screen and (max-width:767px){.not-mobile{display:none}.mobile-only{display:initial}body{overflow:hidden}}", ""]);

// exports
